import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import api from "../../services/api";
import chevronDown from "../../img/icon/down.svg";
import "./style.css"

// Contexto Select modificado para aceitar três argumentos (value, name, color)
const SelectContext = createContext((value: any, name: any, color: any) => { });

export const OptionsRevisao = ({ value, name, selected, color, textDecoration }: any) => {
    const selectContext: any = useContext(SelectContext);
    const [isSelected, setIsSelected] = useState(selected);
    const hasBeenCalled = useRef(false);
  
    useEffect(() => {
      setIsSelected(selected);
    }, [selected]);
  
    useEffect(() => {
      if (selected && !hasBeenCalled.current) {
        selectContext(value, name, color);
        hasBeenCalled.current = true;
      }
    }, [selected, selectContext, value, name, color]);
  
    const handleClick = () => {
      selectContext(value, name, color);
      setIsSelected(true);
    };
  
    return (
      <div
        data-value={value}
        className={`option-dsg ${isSelected ? 'selected' : ''}`}
        style={{ 
          color: color, 
          textDecoration: textDecoration // Aplicando o estilo de risco
        }}
        onClick={handleClick}
      >
        {name}
      </div>
    );
  };


export const SelectRevisao = ({ children, width, onSelect, className, id, selectedValue }: any) => {
  const [selectedOption, setSelectedOption] = useState({ value: '', name: 'Selecione', color: '' });
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedValue) {
      setSelectedOption(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    const mainOption: any = selectRef.current?.querySelector('.option-dsg');
    if (mainOption) {
      mainOption.innerHTML = selectedOption.name;
      mainOption.setAttribute('data-value', selectedOption.value);
      mainOption.style.color = selectedOption.color; // Aplicando a cor
    }
  }, [selectedOption]);

  useEffect(() => {
    const select = selectRef.current;
    if (select) {
      let selects = select.querySelectorAll('.select-dsg');
      selects.forEach((selectElement) => {
        let originalHeight = (selectElement as HTMLElement).offsetHeight;
        let mainOption: any = selectElement.querySelector('.option-dsg');
        let selectedOptionElement: any = selectElement.querySelector('.option-dsg.selected');
        if (selectedOptionElement && mainOption) {
          mainOption.innerHTML = selectedOptionElement.innerHTML;
          mainOption.setAttribute('data-value', selectedOptionElement.getAttribute('data-value') || '');
          mainOption.style.color = selectedOptionElement.style.color; // Aplicando a cor
        }

        selectElement.addEventListener('click', (event) => {
          if ((selectElement as HTMLElement).offsetHeight > originalHeight) {
            (selectElement as HTMLElement).style.height = `${originalHeight}px`;
            if (event.target && (event.target as Element).classList.contains('option-dsg')) {
              if (selectedOptionElement) {
                selectedOptionElement.classList.remove('selected');
              }
              (event.target as Element).classList.add('selected');
              selectedOptionElement = event.target as Element;
              if (mainOption) {
                mainOption.innerHTML = selectedOptionElement.innerHTML;
                mainOption.setAttribute('data-value', selectedOptionElement.getAttribute('data-value') || '');
                mainOption.style.color = selectedOptionElement.style.color; // Aplicando a cor
              }
            }
          } else {
            let optionsCount = (selectElement as HTMLElement).querySelectorAll('.option-dsg').length;
            let optionHeight = ((selectElement as HTMLElement).querySelector('.option-dsg') as HTMLElement)?.offsetHeight || 0;
            (selectElement as HTMLElement).style.height = `${optionsCount * optionHeight}px`;
          }
        });
      });
    }
  }, []);
  const handleSelect = (value: any, name: any, color: any) => {
    setSelectedOption({ value, name, color });
    if (onSelect) {
      onSelect(value);
    }
  };

  return (
    <SelectContext.Provider value={handleSelect}>
      <div className={'select-dsg-content ' + className} ref={selectRef}>
        <div className={`select-dsg ${className}`} id={id} style={{ maxWidth: width }}>
          <div className="select-dsg-ico">
            <img src={chevronDown} alt="down" />
          </div>
          <OptionsRevisao
            value={selectedOption.value}
            name={selectedOption.name}
            color={selectedOption.color}
          />
          <div className='options-content'>
            {children}
          </div>
        </div>
      </div>
    </SelectContext.Provider>
  );
}
